module.exports = __webpack_public_path__ + "static/img/dress_casual_pending.66c54a44.jpg";